var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',[_vm._v("คุณ "+_vm._s(_vm.userData.role == 'admin' ? _vm.userData.data.adminInfo.firstname : (_vm.userData.role == 'adminBranch' ? _vm.userData.data.firstName : _vm.userData.data.customerInfo.firstName)))])])}
var staticRenderFns = []

export { render, staticRenderFns }